import { render, staticRenderFns } from "./PopupEditProject.vue?vue&type=template&id=35d29f30&scoped=true&"
import script from "./PopupEditProject.vue?vue&type=script&lang=js&"
export * from "./PopupEditProject.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35d29f30",
  null
  
)

export default component.exports